import { Cookie } from 'lucide-react';
import React, { useEffect, useState } from 'react';

import { PrivacyPolicyModal } from '@/components/site/PrivacyPolicyModal';
import { Button } from '@/components/ui/Button';
import { ConsentChoice, OPEN_CONSENT_SETTINGS_EVENT, getConsent, setConsent } from '@/lib/consent';

export const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(() => getConsent() === null);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  useEffect(() => {
    const open = () => setIsVisible(true);
    window.addEventListener(OPEN_CONSENT_SETTINGS_EVENT, open);
    return () => window.removeEventListener(OPEN_CONSENT_SETTINGS_EVENT, open);
  }, []);

  const handleChoice = (choice: ConsentChoice) => {
    setConsent(choice);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <div
        className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6 animate-slide-up"
        role="dialog"
        aria-live="polite"
        aria-labelledby="cookie-consent-title"
        aria-describedby="cookie-consent-description"
      >
        <div className="max-w-4xl mx-auto bg-neutral-950 border border-neutral-800 border-l-4 border-l-neon-red shadow-industrial-lg p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
          <div className="flex-1">
            <h2
              id="cookie-consent-title"
              className="flex items-center gap-2 text-white font-bold uppercase tracking-wider text-sm mb-2"
            >
              <Cookie className="w-4 h-4 text-neon-red" aria-hidden="true" />
              Sütik (cookie-k)
            </h2>
            <p
              id="cookie-consent-description"
              className="text-neutral-300 font-body text-sm leading-relaxed"
            >
              Az oldal működéséhez szükséges tárolást mindig használjuk. Statisztikai sütiket
              (Google Analytics) csak a hozzájárulásoddal helyezünk el, hogy lássuk, mely cikkek
              érdekelnek titeket. A döntésedet bármikor módosíthatod az oldal alján a „Süti
              beállítások” linkkel.{' '}
              <button
                type="button"
                onClick={() => setIsPrivacyModalOpen(true)}
                className="text-neon-red underline hover:text-white transition-colors"
              >
                Adatkezelési Tájékoztató
              </button>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 md:flex-col lg:flex-row shrink-0">
            <Button variant="secondary" size="sm" onClick={() => handleChoice('denied')}>
              Elutasítom
            </Button>
            <Button size="sm" onClick={() => handleChoice('granted')}>
              Elfogadom
            </Button>
          </div>
        </div>
      </div>

      <PrivacyPolicyModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
      />
    </>
  );
};
